import { useEffect } from 'react';
import { firebaseService } from '../services/firebaseService';

const FirebaseInitializer = () => {
  useEffect(() => {
    // Initialize Firebase services when the app starts
    console.log('🔥 Firebase initialized successfully');
    
    // Log that the app has started (for analytics)
    firebaseService.logEvent('app_start', {
      timestamp: new Date().toISOString(),
      user_agent: navigator.userAgent
    });

    // You can add more initialization logic here
    // For example:
    // - Set up authentication state listeners
    // - Initialize offline persistence
    // - Set up real-time listeners
    
  }, []);

  // This component doesn't render anything
  return null;
};

export default FirebaseInitializer;
